import { rem, transparentize } from "polished";
import styled, { css } from "styled-components";

const AccordionWrapper = ({ children }) => {
  return <AccordionLayout>{children}</AccordionLayout>;
};
export default AccordionWrapper;

const AccordionLayout = styled.div`
  ${({ theme }) =>
    css`
      .AccordionRoot {
      }

      .AccordionItem {
      }

      .AccordionTrigger {
        width: 100%;
        padding: ${rem(20)} ${rem(30)} ${rem(20)} ${rem(15)};
        transition: 0.3s ease all;
        position: relative;
        border: none;
        text-align: left;
        text-transform: capitalize;

        &::after {
          content: "";
          top: calc(50% - 3px);
          right: 15px;
          position: absolute;
          transform: translateY(-50%) rotate(45deg);
          border-style: solid;
          border-width: 0 1px 1px 0;
          display: inline-block;
          padding: 6px;
          transition: 0.3s ease all;
        }

        &[data-state="open"] {
          background-color: ${theme.colors.primary};
          color: ${theme.colors.white};

          &::after {
            border-color: ${theme.colors.white};
            transform: translateY(-50%) rotate(225deg);
            transform-origin: 9px 9px;
          }
        }
        &[data-state="closed"] {
          background-color: ${theme.colors.gray["500"]};
          color: ${transparentize(0.52, theme.colors.black)};

          &::after {
            border-color: ${theme.colors.black};
          }
        }
      }
      .AccordionContent {
        background-color: ${theme.colors.white};
        overflow: hidden;

        .AccordionContentInner {
          padding: ${rem(20)};
        }
        .label {
          font-size: ${rem(14)};
          margin-bottom: ${rem(15)};
        }

        &[data-state="open"] {
          animation: slideDown 300ms cubic-bezier(0.87, 0, 0.13, 1);
        }
        &[data-state="closed"] {
          animation: slideUp 300ms cubic-bezier(0.87, 0, 0.13, 1);
        }
      }
    `}

  @keyframes slideDown {
    from {
      height: 0;
    }
    to {
      height: var(--radix-accordion-content-height);
    }
  }

  @keyframes slideUp {
    from {
      height: var(--radix-accordion-content-height);
    }
    to {
      height: 0;
    }
  }
`;
